import { LineChart } from '@/components/charts/LineChart';

function BaseComponent({
  data,
  dot,
}: {
  data: {
    name: string;
    jobs: number;
  }[];
  dot?: boolean;
}) {
  return (
    <LineChart
      dot={dot}
      data={data}
      lines={[
        {
          dataKey: 'jobs',
          dotClassName: 'stroke-chariot-brand-primary',
          lineClassName:
            '[&>path]:stroke-chariot-brand-primary text-chariot-brand-primary',
        },
      ]}
    />
  );
}

const sampleData = [...Array(24).keys()].map(i => ({
  name: `${i}:00`,
  jobs: Math.floor(Math.random() * 20) + 5,
}));

export function JobsRunningOverTimeExample() {
  return <BaseComponent data={sampleData} dot={false} />;
}
